export default __webpack_public_path__ + "static/media/gl_3.a432ad72.png";